import React from 'react';
import { FadeIn } from './FadeIn';
export function Hook() {
  return <section className="py-24 md:py-32 bg-[#0B1029] relative" data-id="element-137">
      <div className="container mx-auto px-6 max-w-3xl" data-id="element-138">
        <FadeIn data-id="element-139">
          <p className="text-xl md:text-2xl text-slate-300 leading-relaxed mb-8 font-light" data-id="element-140">
            You're staring at the ceiling again. Your eyes snapped open at 3:14
            AM—exactly like they did last night, and the night before.
          </p>
          <p className="text-xl md:text-2xl text-slate-300 leading-relaxed mb-12 font-light" data-id="element-141">
            Your heart is racing slightly. A sudden wave of heat is crawling up
            your neck. You try to close your eyes, but your brain is already
            listing every mistake you've made since 1998.
          </p>
          <div className="pl-6 border-l-2 border-[#F5D0A9]/40" data-id="element-142">
            <p className="text-2xl md:text-3xl text-white font-serif italic leading-relaxed" data-id="element-143">
              You aren't just tired; you're "wired and tired," trapped in a
              hormonal biological ambush that no amount of melatonin or lavender
              spray can fix.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}